import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"
import { 
  MAX_NUMBER_OF_REVOLUTIONS,
  defaultUnitParams
} from "./constants"

const defaultAmmunitionParams = () => {
  const initialAmmunitionValue = "other"

  return {
    currentAmmunition: initialAmmunitionValue,
    currentAmmunitionBrand: initialAmmunitionValue,
    currentAmmunitionCaliber: initialAmmunitionValue,
  }
}

const existingCustomizationToStateParams = (existingCustomization) => {
  let ammunitionParams = {
    currentAmmunition: "other",
    currentAmmunitionBrand: "other",
    currentAmmunitionCaliber: "other"
  }

  if (existingCustomization.ammunition) {
    ammunitionParams = {
      currentAmmunition: existingCustomization.ammunition,
      currentAmmunitionBrand: existingCustomization.ammunition.brand,
      currentAmmunitionCaliber: existingCustomization.ammunition.caliber
    }
  }

  return Object.assign({}, ammunitionParams, {
    // Turret
    isImperial: existingCustomization["is_imperial"],
    turretHeight: existingCustomization["turret_height"],
    turretDiameter: existingCustomization["turret_diameter"],
    // Scope
    sightHeight: existingCustomization["sight_height"],
    clickUnit: existingCustomization["click_unit"],
    clickValue: existingCustomization["click_value"],
    clicksPerRotation: existingCustomization["clicks_per_rotation"],
    direction: existingCustomization["direction"],
    numberOfRevolutions: existingCustomization["number_of_revolutions"],
    maxNumberOfRevolutions: existingCustomization.scope ? existingCustomization.scope["number_of_revolutions"] : MAX_NUMBER_OF_REVOLUTIONS,
    // Ammunition
    dragFunction: existingCustomization["drag_function"],
    dragCoefficient: existingCustomization["drag_coefficient"],
    ammunitionWeight: existingCustomization["ammunition_weight"],
    // Firearm
    initialVelocity: existingCustomization["initial_velocity"],
    zeroRange: existingCustomization["zero_range"],
    // Environment
    altitude: existingCustomization.altitude,
    pressure: existingCustomization.pressure,
    temperature: existingCustomization.temperature,
    humidity: existingCustomization.humidity,

    // Product
    currentScopeProductVariant: existingCustomization.scope.turret.product_variants.find(product_variant => {
      return product_variant.id === existingCustomization['product_variant_id']
    })
  })
}

const currentScopeToStateParams = (currentScope) => ({
  turretHeight: currentScope.turret.height,
  turretDiameter: currentScope.turret.diameter,
  direction: currentScope.rotation,
  sightHeight: currentScope.height,
  clickUnit: currentScope.unit,
  clickValue: currentScope["click_value"],
  clicksPerRotation: currentScope["clicks_per_rotation"],
  maxNumberOfRevolutions: currentScope["number_of_revolutions"]
})

const getCurrentScopeBrand = (currentScope, currentBrand) => {
  let currentScopeBrand

  if (currentScope) {
    currentScopeBrand = currentScope.brand
  } else if (currentBrand) {
    currentScopeBrand = currentBrand
  } else {
    currentScopeBrand = "other"
  }

  return currentScopeBrand
}

const initialState = (ammunitions, currentScope, currentBrand, existingCustomization = {}) => {
  let customParams = {}

  if (existingCustomization && Object.keys(existingCustomization).length) {
    customParams = existingCustomizationToStateParams(existingCustomization)
  } else if (currentScope) {
    customParams = currentScopeToStateParams(currentScope)
  }
  
  const isImperialDefault = true;

  const defaultStateParams = {
    ammunitions,
    currentBrand,
    currentScope: currentScope ? currentScope : "other",
    currentScopeBrand: getCurrentScopeBrand(currentScope, currentBrand),
    currentScopeProductVariant: currentScope.turret.product_variants[0],
    isCalculationLoading: false,
    calculationResults: [],
    isImperial: isImperialDefault,
    clickUnit: "moa",
    clickValue: 0.5,
    clicksPerRotation: 50,
    direction: "counter_clockwise",
    numberOfRevolutions: 1,
    maxNumberOfRevolutions: MAX_NUMBER_OF_REVOLUTIONS,
    dragFunction: 1,
    dragCoefficient: 0.4,
    ammunitionWeight: 110,
    zeroRange: 200,
    pressure: 29.53,
    humidity: 78,
    ...defaultAmmunitionParams(ammunitions),
    ...defaultUnitParams(isImperialDefault),
  }

  const turretData = Object.assign({}, defaultStateParams, customParams);

  return turretData
}

export default (ammunitions, currentScope, currentBrand, existingCustomization) => ({
  namespaced: true,
  state: initialState(ammunitions, currentScope, currentBrand, existingCustomization),
  actions: actions,
  getters: getters,
  mutations: mutations
})
